// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {connect} from 'react-redux';

import {canManageChannelMembers} from 'mattermost-redux/selectors/entities/channels';

import ChannelMembersModal from './channel_members_modal';

function mapStateToProps(state) {
    return {
        canManageChannelMembers: canManageChannelMembers(state)
    };
}

export default connect(mapStateToProps)(ChannelMembersModal);



// WEBPACK FOOTER //
// ./components/channel_members_modal/index.js